import { Table, Tag } from "antd";
import dayjs from "dayjs";

export const statusColors = {
  completed: { bg: "#e6fffb", color: "#006d75", border: "#87e8de" },
  pending: { bg: "#fffbe6", color: "#ad8b00", border: "#ffe58f" },
  failed: { bg: "#fff2f0", color: "#cf1322", border: "#ffa39e" },
};

export const getTagStyle = (status) => {
  const colors = statusColors[status];
  return {
    backgroundColor: colors?.bg || "#f5f5f5",
    color: colors?.color || "#000",
    padding: "2px 10px",
    borderRadius: "6px",
    fontSize: "0.65rem",
    border: `1px solid ${colors?.border || "#d9d9d9"}`,
    fontWeight: 600,
    cursor: "default",
  };
};

export default function PayoutTransactionsTable({ payouts = [], loading }) {
  const columns = [
    {
      title: "Transfer Ref",
      dataIndex: "stripeTransferId",
      key: "stripeTransferId",
      ellipsis: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (v) => `$${(v / 100).toFixed(2)}`,
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      render: (v) => v?.toUpperCase(),
    },
    {
      title: "Sender ID",
      dataIndex: "senderUserId",
      key: "senderUserId",
      ellipsis: true,
    },
    {
      title: "Recipient ID",
      dataIndex: "recipientUserId",
      key: "recipientUserId",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag style={getTagStyle(status)}>{status.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Transferred At",
      dataIndex: "transferredAt",
      key: "transferredAt",
      render: (v) => (v ? dayjs(v).format("YYYY-MM-DD HH:mm") : "-"),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={payouts}
      pagination={{ pageSize: 10 }}
      loading={loading}
      className="custom-table"
      size="small"
      scroll={{ x: 600 }}
      expandable={{
        expandedRowRender: (record) => (
          <div style={{ paddingLeft: 50 }}>
            <p className="mb-2 pb-0">
              <strong>Transfer Ref:</strong> {record.stripeTransferId}
            </p>
            <p className="mb-2 pb-0">
              <strong>Sender:</strong> {record.senderUserId}
            </p>
            <p className="mb-2 pb-0">
              <strong>Recipient:</strong> {record.recipientUserId}
            </p>
            <p className="mb-2 pb-0">
              <strong>Amount:</strong> ${(record.amount / 100).toFixed(2)}{" "}
              {record.currency?.toUpperCase()}
            </p>
            <p className="mb-2 pb-0">
              <strong>Status:</strong> {record.status.toUpperCase()}
            </p>
            <p className="mb-2 pb-0">
              <strong>Transferred At:</strong>{" "}
              {record.transferredAt
                ? dayjs(record.transferredAt).format("YYYY-MM-DD HH:mm")
                : "-"}
            </p>
            <p className="mb-2 pb-0">
              <strong>Created At:</strong>{" "}
              {record.createdAt
                ? dayjs(record.createdAt).format("YYYY-MM-DD HH:mm")
                : "-"}
            </p>
            <p className="mb-2 pb-0">
              <strong>Updated At:</strong>{" "}
              {record.updatedAt
                ? dayjs(record.updatedAt).format("YYYY-MM-DD HH:mm")
                : "-"}
            </p>
            <p className="mb-2 pb-0">
              <strong>Raw Stripe Response:</strong>{" "}
              <pre style={{ maxHeight: 150, overflow: "auto" }}>
                {JSON.stringify(record.rawStripeResponse, null, 2)}
              </pre>
            </p>
          </div>
        ),
        rowExpandable: () => true,
      }}
    //   locale={{
    //     emptyText: "No payouts found 😕",
    //   }}
    />
  );
}
